import React from "react";
import { makeStyles } from "tss-react/mui";
import { Icon } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useStyles = makeStyles()((theme) => ({
  selectArrowIcon: {
    fontSize: "10px !important",
    color: theme.palette.text.secondary
  },
  selectArrowIconOpen: {
    color: theme.palette.primary.main
  }
}));
function SelectArrowIcon({ selectOpen }) {
  const { classes, cx } = useStyles();
  return /* @__PURE__ */ React.createElement(
    Icon,
    {
      icon: selectOpen ? CustomIcon.ArrowUp : CustomIcon.ArrowDown,
      className: cx({ [classes.selectArrowIconOpen]: selectOpen }, classes.selectArrowIcon)
    }
  );
}
export {
  SelectArrowIcon
};
//# sourceMappingURL=SelectArrowIcon.js.map
